import { Box, Button } from '@mui/material';
import { FC } from 'react';
import { usePermissionsManagerContext } from '../context';
import { FormActionTypeEnum } from '../models';

export const Header: FC<{}> = () => {
  const { setStateDialog } = usePermissionsManagerContext();

  return (
    <Box
      sx={{
        width: '100%',
        height: 60,
        minHeight: 60,
        backgroundColor: 'colors.gray.o10',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        px: 2,
      }}
    >
      <Button
        variant="contained"
        onClick={e => {
          e.stopPropagation();
          setStateDialog({
            actionType: FormActionTypeEnum.ADD,
            open: true,
            defaultValues: {
              parentPath: '',
              name: '',
              code: '',
              dependenciesApiPermissions: [],
            },
          });
        }}
      >
        ADD
      </Button>
    </Box>
  );
};
